import styled from 'styled-components';
import Colours from '/shared/styled/Colours';

export default styled.div`
  max-width: 400px;

  span {
    display: block;
    font-size: 0.8rem;
    margin-bottom: 1.5rem;
  }

  div {
    font-size: 1.7rem;
    color: ${Colours.white};
    font-weight: 700;
  }
`;
